// extracted by mini-css-extract-plugin
export default {"loading":"index-module__loading___F9BUV"};